import { Loader2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  confirmText: string;
  /** Libellé du bouton de confirmation (défaut « Supprimer »). */
  confirmLabel?: string;
  onConfirm: () => void | Promise<void>;
  isPending: boolean;
}

/** Confirmation de suppression réutilisable (soft-delete). */
export function ConfirmDelete({
  open,
  onOpenChange,
  title,
  description,
  confirmText,
  confirmLabel = "Supprimer",
  onConfirm,
  isPending,
}: Props) {
  return (
    // Ignore la fermeture (Échap / clic extérieur / bouton Annuler) tant que la
    // suppression est en vol : sinon la cible est effacée pendant que la
    // requête est encore en cours.
    <Dialog open={open} onOpenChange={(v) => !isPending && onOpenChange(v)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogBody>
          <p className="text-sm text-muted-foreground">{confirmText}</p>
        </DialogBody>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isPending}>
            Annuler
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={isPending}>
            {isPending && <Loader2 className="h-4 w-4 animate-spin" />}
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
